// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2k0nA","gfeWrapper":"CalendarEvent_gfeWrapper__Xndg3"};